import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import UserLink from '../../../../User/Link/UserLink';
import s from './Subjects.scss';
export var Subjects = function (_a) {
    var className = _a.className, subjectTags = _a.subjectTags, locationTag = _a.locationTag;
    var t = useTranslation().t;
    if ((!subjectTags || !subjectTags.length) && !locationTag) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], className) },
        subjectTags &&
            subjectTags.map(function (subject) { return (React.createElement("span", { key: subject.name, className: s['subject'] },
                React.createElement("span", { className: s['subject-title'] }, t("deviation.subject." + subject.type)),
                "\u00A0\u00A0",
                subject.user && React.createElement(UserLink, { user: subject.user }),
                !subject.user && (React.createElement("a", { className: s['subject-name'], href: subject.url }, subject.name)))); }),
        locationTag && (React.createElement("span", { className: s['subject'] },
            React.createElement("span", { className: s['subject-title'] }, t('deviation.subject.location')),
            "\u00A0\u00A0",
            React.createElement("a", { className: s['subject-name'], href: locationTag.url }, locationTag.name)))));
};
Subjects.displayName = 'Subjects';
export default Subjects;
//# sourceMappingURL=Subjects.js.map